<template>
  <div class="browsing-history">
    <nav-bar title="浏览记录" left-text>
      <template #btn>
        <button v-show="!noRecords" @click="clearHistory">清空记录</button>
      </template>
    </nav-bar>
    <div class="browsing-history-wrapper" v-show="browsingList.length">
      <div class="title">最近{{browsingList.length}}条浏览记录</div>
      <div>
        <product-single :list="browsingList"></product-single>
      </div>
    </div>
    <div class="no-records" v-show="noRecords && !browsingList.length">
      <p>暂无浏览记录</p>
    </div>
  </div>
</template>

<script>
import NavBar from '../components/NavBar'
import ProductSingle from '../components/ProductSingle'
let flag = false
export default {
  name: 'browsingHistory',
  components: {
    NavBar,
    ProductSingle
  },
  data () {
    return {
      browsingList: [],
      noRecords: false
    }
  },
  created () {
    this.$toast.loading({
      message: '正在加载...',
      duration: 300000
    })
    this.getBrowsingList()
  },
  methods: {

    /**
     * 清空浏览记录
    */
    async clearHistory () {
      if (flag) {
        return
      }
      flag = true
      const res = await this.$axios.get('api/goods/clear')
      if (res.status === 200) {
        flag = false
        const { code, msg } = res.data
        if (code === 0) {
          this.browsingList = []
          this.noRecords = true
          this.$toast('清除成功')
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 获取浏览记录列表
    */
    async getBrowsingList () {
      const res = await this.$axios.get('api/goods/record')
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.browsingList = data
        } else if (code === 9006) {
          this.noRecords = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.browsing-history {
  .browsing-history-wrapper {
    margin: 0.3rem 0.2rem;
    .title {
      font-weight: bold;
      font-size: @fz32;
      color: @base;
      padding-bottom: 0.2rem;
      border-bottom: 0.5px solid #C5C5C5;
    }
  }
  .no-records {
    font-size: 0.34rem;
    color: @c80;
    text-align: center;
    padding: 2rem 0;
  }
}
</style>
